var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Header'),_c('v-content',[_c('ContentBar',{on:{"backToBuilder":function($event){return _vm.onBackToBuilder(false)}}}),_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }